<!-- Create a new component: TypingIndicator.vue -->
<template>
  <div class="typing-container" style="display: flex; align-items: center; height: 20px; gap: 3px;">
    <div 
      v-for="(dot, index) in dots" 
      :key="index"
      class="typing-dot"
      :style="{
        width: '6px',
        height: '6px',
        backgroundColor: '#9ca3af',
        borderRadius: '50%',
        opacity: dot.opacity,
        transform: `translateY(${dot.translateY}px)`,
        transition: 'all 0.3s ease'
      }"
    ></div>
    <span style="margin-left: 8px; color: #9ca3af; font-size: 12px; font-style: italic;">
      tippt...
    </span>
  </div>
</template>

<script>
export default {
  name: 'TypingIndicator',
  data() {
    return {
      dots: [
        { opacity: 0.3, translateY: 0 },
        { opacity: 0.3, translateY: 0 },
        { opacity: 0.3, translateY: 0 }
      ],
      animationInterval: null,
      currentStep: 0
    }
  },
  mounted() {
    this.startAnimation();
  },
  beforeUnmount() {
    this.stopAnimation();
  },
  methods: {
    startAnimation() {
      this.animationInterval = setInterval(() => {
        // Reset all dots
        this.dots.forEach(dot => {
          dot.opacity = 0.3;
          dot.translateY = 0;
        });
        
        // Animate current dot
        const dotIndex = this.currentStep % 3;
        this.dots[dotIndex].opacity = 1;
        this.dots[dotIndex].translateY = -3;
        
        this.currentStep++;
      }, 400); // Change every 400ms
    },
    
    stopAnimation() {
      if (this.animationInterval) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
      }
    }
  }
}
</script>